"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConditionAssignee = exports.isWriteAccess = exports.shareCodntionAccessLevelToString = exports.ShareConditionAccessLevel = exports.createConditionFromXlSXRow = exports.createDefaultShareCondition = exports.createDefaultCondition = exports.createImportedCondition = exports.conditionStatusToColor = exports.conditionStatusToString = exports.ConditionStatus = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
var uuid_1 = require("uuid");
var profile_1 = require("./profile");
var condition_1 = require("../decoders/condition");
var EntityCondition = __importStar(require("../entities/condition"));
var richText_1 = require("../utils/richText");
var string_1 = require("../utils/string");
dayjs_1.default.extend(customParseFormat_1.default);
var ConditionStatus;
(function (ConditionStatus) {
    ConditionStatus["NotAssigned"] = "condition-status_not-assigned";
    ConditionStatus["Assigned"] = "condition-status_assigned";
    ConditionStatus["InReview"] = "condition-status_in_review";
    ConditionStatus["Rejected"] = "condition-status_rejected";
    ConditionStatus["Approved"] = "condition-status_approved";
    ConditionStatus["Overdue"] = "condition-status_overdue";
})(ConditionStatus || (exports.ConditionStatus = ConditionStatus = {}));
var conditionStatusToString = function (conditionStatus, markedAsNotApplicable) {
    if (markedAsNotApplicable) {
        return "Not Applicable";
    }
    switch (conditionStatus) {
        case ConditionStatus.NotAssigned:
            return "Not Assigned";
        case ConditionStatus.Assigned:
            return "Assigned";
        case ConditionStatus.InReview:
            return "In Review";
        case ConditionStatus.Rejected:
            return "Rejected";
        case ConditionStatus.Approved:
            return "Approved";
        case ConditionStatus.Overdue:
            return "Overdue";
    }
};
exports.conditionStatusToString = conditionStatusToString;
var conditionStatusToColor = function (conditionStatus, markedAsNotApplicable) {
    if (markedAsNotApplicable) {
        return "#A9A9A9";
    }
    switch (conditionStatus) {
        default:
        case ConditionStatus.NotAssigned:
            return "#FCF5D9";
        case ConditionStatus.Approved:
            return "#AEE2AE";
        case ConditionStatus.Overdue:
        case ConditionStatus.Rejected:
            return "#FCC8CF";
        case ConditionStatus.InReview:
            return "#FCDECA";
        case ConditionStatus.Assigned:
            return "#BEE1F4";
    }
};
exports.conditionStatusToColor = conditionStatusToColor;
var createImportedCondition = function (project, permit, conditionDetails, conditionComments, conditionAuthority, discipline, conditionCount) {
    var permitItemNumber = conditionCount + 1;
    return {
        approvers: [],
        assignees: [],
        collaborators: "",
        condition_authority: conditionAuthority,
        condition_comments: conditionComments,
        condition_details: conditionDetails,
        condition_id: (0, uuid_1.v4)(),
        created: new Date(),
        discipline: discipline,
        discipline_other: "",
        due_date: new Date(),
        managers: [],
        permit_id: permit.permit_id,
        permit_item_number: permitItemNumber,
        permit_name: permit.permit_name,
        permit_type: permit.permit_type,
        project_id: project.project_id,
        status: ConditionStatus.NotAssigned,
    };
};
exports.createImportedCondition = createImportedCondition;
var createDefaultCondition = function (project, permit, conditionCount) {
    var permitItemNumber = conditionCount + 1;
    return {
        approvers: [],
        assignees: [],
        collaborators: "",
        conditionAuthority: EntityCondition.ConditionAuthority.BCA,
        conditionName: (0, string_1.generateConditionName)(permitItemNumber),
        created: new Date(),
        discipline: "",
        disciplineOther: "",
        dueDate: new Date(),
        id: (0, uuid_1.v4)(),
        managers: [],
        permitId: permit.id,
        permitItemNumber: permitItemNumber,
        permitName: permit.permitName,
        permitType: permit.permitType,
        projectId: project.id,
        status: ConditionStatus.NotAssigned,
    };
};
exports.createDefaultCondition = createDefaultCondition;
var createDefaultShareCondition = function (email, firstName, lastName, projectId, permitId, accessLevel) {
    return {
        accessLevel: accessLevel,
        email: email,
        firstName: firstName,
        id: (0, uuid_1.v4)(),
        lastName: lastName,
        permitId: permitId,
        projectId: projectId,
    };
};
exports.createDefaultShareCondition = createDefaultShareCondition;
var getEmailsFromCell = function (cell) {
    if (cell) {
        if ((0, richText_1.isHyperLink)(cell)) {
            var emails = cell.text.split(",");
            return emails.map(function (email) { return (0, profile_1.createInvite)(email); });
        }
        else if ((0, richText_1.isRichText)(cell)) {
            var emails = cell;
            var invites_1 = [];
            var re_1 = /[^< ]+(?=>)/g;
            emails.richText.forEach(function (_a) {
                var text = _a.text;
                if (text) {
                    var matches = text.match(re_1);
                    if (matches) {
                        matches.forEach(function (m) {
                            invites_1.push((0, profile_1.createInvite)(m));
                        });
                    }
                }
            });
            return invites_1;
        }
        else {
            var emails = cell.split(",");
            return emails.map(function (email) { return (0, profile_1.createInvite)(email); });
        }
    }
    return [];
};
var createConditionFromXlSXRow = function (project, permit, conditionData, permitCount) {
    var _a;
    var assignees = getEmailsFromCell(conditionData[6]);
    var dueDate = new Date();
    if (typeof conditionData[7] === "string") {
        var dateParts = conditionData[7]
            ? conditionData[7].toString().split("/")
            : undefined;
        dueDate = dateParts
            ? new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]))
            : new Date();
    }
    else {
        dueDate = conditionData[7];
    }
    return {
        assignees: assignees,
        collaborators: "",
        conditionComments: (0, richText_1.formatHtmlText)(conditionData[2]) || "",
        conditionDetails: (0, richText_1.formatText)(((_a = conditionData[1]) === null || _a === void 0 ? void 0 : _a.toString()) || ""),
        conditionName: (0, string_1.generateConditionName)(permitCount),
        created: new Date(),
        discipline: (0, condition_1.decodeImportedConditionDiscipline)(conditionData[4]),
        disciplineOther: conditionData[5] || "",
        dueDate: dueDate,
        id: (0, uuid_1.v4)(),
        permitId: permit.id,
        permitItemNumber: permitCount,
        permitName: permit.permitName,
        projectId: permit.projectId,
        status: assignees.length > 0
            ? ConditionStatus.Assigned
            : ConditionStatus.NotAssigned,
    };
};
exports.createConditionFromXlSXRow = createConditionFromXlSXRow;
var ShareConditionAccessLevel;
(function (ShareConditionAccessLevel) {
    ShareConditionAccessLevel["NoAccess"] = "share-condition-access-level_no-access";
    ShareConditionAccessLevel["Read"] = "share-condition-access-level_read";
    ShareConditionAccessLevel["Write"] = "share-condition-access-level_write";
})(ShareConditionAccessLevel || (exports.ShareConditionAccessLevel = ShareConditionAccessLevel = {}));
var shareCodntionAccessLevelToString = function (accessLevel) {
    switch (accessLevel) {
        case ShareConditionAccessLevel.NoAccess:
            return "No Access";
        case ShareConditionAccessLevel.Read:
            return "Viewer";
        case ShareConditionAccessLevel.Write:
            return "Manager";
    }
};
exports.shareCodntionAccessLevelToString = shareCodntionAccessLevelToString;
var isWriteAccess = function (accessLevel) {
    return accessLevel === ShareConditionAccessLevel.Write;
};
exports.isWriteAccess = isWriteAccess;
var isConditionAssignee = function (condition, profile) {
    return condition.assignees.includes(profile);
};
exports.isConditionAssignee = isConditionAssignee;
